import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground } from 'docz';
import { PlayState, Tween } from './../../../react-gsap/src/';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "low-level-access"
    }}>{`Low-level access`}</h1>
    <p>{`You are able to use the complete API of the underlying GSAP objects.
Just add a reference to the React `}<inlineCode parentName="p">{`Tween`}</inlineCode>{` or `}<inlineCode parentName="p">{`Timeline`}</inlineCode>{` components and get the `}<inlineCode parentName="p">{`Tween`}</inlineCode>{` or `}<inlineCode parentName="p">{`Timeline`}</inlineCode>{` objects from GSAP by calling the getGSAP() method on it:`}</p>
    <pre><code parentName="pre" {...{}}>{`import { PlayState, Tween } from 'react-gsap';
`}</code></pre>
    <h3 {...{
      "id": "usage-with-tween"
    }}>{`Usage with Tween`}</h3>
    <Playground __position={0} __code={'() => {\n  const tween = React.useRef(null)\n  return (\n    <Fragment>\n      <Tween\n        ref={tween}\n        to={{ x: \'200px\' }}\n        duration={2}\n        playState={PlayState.stop}\n      >\n        <div\n          style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }}\n        />\n      </Tween>\n      <button onClick={() => tween.current.getGSAP().play(0)}>Play</button>\n      <button onClick={() => tween.current.getGSAP().seek(1)}>Seek</button>\n      <button onClick={() => tween.current.getGSAP().pause(0)}>Stop</button>\n    </Fragment>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      PlayState,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const tween = React.useRef(null);
        return <Fragment mdxType="Fragment">
        <Tween ref={tween} to={{
            x: '200px'
          }} duration={2} playState={PlayState.stop} mdxType="Tween">
          <div style={{
              width: '100px',
              height: '100px',
              background: '#ccc'
            }} />
        </Tween>
        <button onClick={() => tween.current.getGSAP().play(0)}>
          Play
        </button>
        <button onClick={() => tween.current.getGSAP().seek(1)}>
          Seek
        </button>
        <button onClick={() => tween.current.getGSAP().pause(0)}>
          Stop
        </button>
      </Fragment>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      